// DS: CR59
/** An image link in card form that displays art and title
 *  associated with a _popular_ topic.
 */
import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import {
  BiContextProvidedValue,
  BiData,
  ItemClickBiEvent,
} from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import DeviationDumbo from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';

import s from './TopTopicCard.scss';

export interface Props {
  /** resource type for topics */
  typeId?: number;
  /** neco id for this topic */
  itemId?: number;
  /** the topic location in the app (e.g. '/topic/digital_art') */
  url: string;
  /** the topic name (e.g. 'Digital Art') */
  name: string;
  /** deviation used for a cover */
  deviation?: PapiDeviation;
  /** the horizontal column width in pixels */
  width: number;
  className?: string;
  rank?: number;
}

const TopTopicCard: React.FC<Props> = props => {
  const { url, name, deviation, width, className, typeId, itemId, rank } =
    props;
  if (!url || !name || !width) {
    return null;
  }

  const classNames = classnames(
    s.root,
    className,
    !deviation && s['missing-bg']
  );
  const linkStyles = { width };
  return (
    <BiLink
      href={url}
      style={linkStyles}
      className={classNames}
      biData={BiData<ItemClickBiEvent>({
        evid: 100,
        typeid: typeId,
        itemid: itemId,
        rank,
        sectionname: BiContextProvidedValue,
      })}
    >
      <Heading className={s['name']}>{name}</Heading>

      {deviation && (
        <DeviationDumbo
          className={s[`cover`]}
          deviation={deviation}
          width={width}
        />
      )}
    </BiLink>
  );
};
TopTopicCard.displayName = 'TopTopicCardCR59';
export default TopTopicCard;
